/* eslint-disable react/no-danger */
import React, { useCallback } from 'react';
import { string, func, node } from 'prop-types';

import { Image } from '@thd-olt-component-react/image';

import { usePromoPresentation } from '../../../../contexts/PromoPresentationProvider';
import './PromoQuickviewSectionCta.scss';

export const PromoQuickviewSectionCta = ({
  setOpen, setRender, clickAnalytics, sectionName, children
}) => {
  const { isAppleMobileDevice } = usePromoPresentation();

  const openSection = useCallback((event) => {
    if (event) event.preventDefault();
    setRender(true);
    setOpen(true);
    clickAnalytics(sectionName === 'Specs' ? 'specifications' : sectionName.toLowerCase());
  }, [setOpen, setRender, clickAnalytics, sectionName]);

  const loadSection = useCallback((event) => {
    if (event) event.preventDefault();
    setRender(true);
  }, [setRender]);

  return (
    <section
      className="promo-quickview-section"
      role="button"
      tabIndex={0}
      onMouseEnter={isAppleMobileDevice ? undefined : loadSection}
      onClick={openSection}
    >
      <span className="u__bold">{sectionName}</span>
      { children }
      <Image
        className="promo-quickview-section-caret"
        alt={`Open ${sectionName}`}
        src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
      />
    </section>
  );
};

PromoQuickviewSectionCta.displayName = 'PromoQuickviewSectionCta';

PromoQuickviewSectionCta.propTypes = {
  setOpen: func.isRequired,
  setRender: func.isRequired,
  clickAnalytics: func.isRequired,
  sectionName: string.isRequired,
  children: node,
};

PromoQuickviewSectionCta.defaultProps = {
  children: null,
};
